import { Vehicle } from './Vehicle';
import { LevelUtil } from '../level/levels/LevelUtil';

export interface PlayerControls {
  changeLaneUp: Phaser.Input.Keyboard.Key;
  changeLaneUpAlt: Phaser.Input.Keyboard.Key;
  changeLaneDown: Phaser.Input.Keyboard.Key;
  changeLaneDownAlt: Phaser.Input.Keyboard.Key;
  accelerate: Phaser.Input.Keyboard.Key;
}

export interface DebugPlayerControls {
  toggleDebugMovement: Phaser.Input.Keyboard.Key;
  // up: Phaser.Input.Keyboard.Key;
  // upSecond: Phaser.Input.Keyboard.Key;
  // down: Phaser.Input.Keyboard.Key;
  // downSecond: Phaser.Input.Keyboard.Key;
  left: Phaser.Input.Keyboard.Key;
  leftSecond: Phaser.Input.Keyboard.Key;
  right: Phaser.Input.Keyboard.Key;
  rightSecond: Phaser.Input.Keyboard.Key;
  jumpReset: Phaser.Input.Keyboard.Key;
  autoRun: Phaser.Input.Keyboard.Key;
}

export class PlayerController {
  public static events = {} as const;

  protected scene: Phaser.Scene;
  protected player: Vehicle;

  protected playerControls: PlayerControls;
  protected debugControls: DebugPlayerControls;

  protected allowDebugControls: boolean;
  protected allowDebugMovement: boolean;

  protected isLaneChangingUp: boolean;
  protected isLaneChangingDown: boolean;

  protected isPointerDown: boolean;
  protected pointerSensitivity: number;
  protected previousPointerY: number;
  protected pointerTargetY: number;
  protected pointerTargetYDiff: number;

  constructor(scene: Phaser.Scene, player: Vehicle) {
    this.scene = scene;
    this.player = player;

    this.playerControls = this.scene.input.keyboard.addKeys({
      changeLaneUp: Phaser.Input.Keyboard.KeyCodes.W,
      changeLaneUpAlt: Phaser.Input.Keyboard.KeyCodes.UP,
      changeLaneDown: Phaser.Input.Keyboard.KeyCodes.S,
      changeLaneDownAlt: Phaser.Input.Keyboard.KeyCodes.DOWN,
      accelerate: Phaser.Input.Keyboard.KeyCodes.SPACE
    }) as PlayerControls;

    this.debugControls = this.scene.input.keyboard.addKeys({
      toggleDebugMovement: Phaser.Input.Keyboard.KeyCodes.T,
      // up: Phaser.Input.Keyboard.KeyCodes.W,
      // upSecond: Phaser.Input.Keyboard.KeyCodes.UP,
      // down: Phaser.Input.Keyboard.KeyCodes.S,
      // downSecond: Phaser.Input.Keyboard.KeyCodes.DOWN,
      left: Phaser.Input.Keyboard.KeyCodes.A,
      leftSecond: Phaser.Input.Keyboard.KeyCodes.LEFT,
      right: Phaser.Input.Keyboard.KeyCodes.D,
      rightSecond: Phaser.Input.Keyboard.KeyCodes.RIGHT,
      autoRun: Phaser.Input.Keyboard.KeyCodes.Q
    }) as DebugPlayerControls;

    this.allowDebugControls = !__IS_PRODUCTION__;
    this.allowDebugMovement = false;

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);

    this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
    this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
    this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
    this.scene.input.on(Phaser.Input.Events.POINTER_UP_OUTSIDE, this.onPointerUpOutside, this);

    // this.playerControls.accelerate.on(Phaser.Input.Keyboard.Events.DOWN, this.accelerateDown, this);
    // this.playerControls.accelerate.on(Phaser.Input.Keyboard.Events.UP, this.accelerateUp, this);
    this.playerControls.changeLaneUpAlt.on(Phaser.Input.Keyboard.Events.DOWN, this.upKeyDown, this);
    this.playerControls.changeLaneUpAlt.on(Phaser.Input.Keyboard.Events.UP, this.upKeyUp, this);
    this.playerControls.changeLaneDownAlt.on(Phaser.Input.Keyboard.Events.DOWN, this.downKeyDown, this);
    this.playerControls.changeLaneDownAlt.on(Phaser.Input.Keyboard.Events.UP, this.downKeyUp, this);

    this.player.on(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);

      this.scene.input.off(Phaser.Input.Events.POINTER_DOWN, this.onPointerDown, this);
      this.scene.input.off(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
      this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
      this.scene.input.off(Phaser.Input.Events.POINTER_UP_OUTSIDE, this.onPointerUpOutside, this);

      // this.playerControls.accelerate.off(Phaser.Input.Keyboard.Events.DOWN, this.accelerateDown, this);
      // this.playerControls.accelerate.off(Phaser.Input.Keyboard.Events.UP, this.accelerateUp, this);
      this.playerControls.changeLaneUpAlt.off(Phaser.Input.Keyboard.Events.DOWN, this.upKeyDown, this);
      this.playerControls.changeLaneUpAlt.off(Phaser.Input.Keyboard.Events.UP, this.upKeyUp, this);
      this.playerControls.changeLaneDownAlt.off(Phaser.Input.Keyboard.Events.DOWN, this.downKeyDown, this);
      this.playerControls.changeLaneDownAlt.off(Phaser.Input.Keyboard.Events.UP, this.downKeyUp, this);
    });

    this.isLaneChangingUp = false;
    this.isLaneChangingDown = false;

    this.isPointerDown = false;
    this.pointerSensitivity = 1;
    this.previousPointerY = 0;
    this.pointerTargetY = this.player.y;
    this.pointerTargetYDiff = 0;
  }

  private accelerateDown() {
    this.player.accelerateX();
  }

  private accelerateUp() {
    this.player.decelerateX();
  }

  private upKeyDown() {
    // this.player.isLaneChangingUp = true;
    this.isLaneChangingUp = true;
  }

  private upKeyUp() {
    // this.player.isLaneChangingUp = false;
    this.isLaneChangingUp = false;
  }

  private downKeyDown() {
    // this.player.isLaneChangingDown = true;
    this.isLaneChangingDown = true;
  }

  private downKeyUp() {
    // this.player.isLaneChangingDown = false;
    this.isLaneChangingDown = false;
  }

  public update(time: number, delta: number) {
    // this.updateTargetYDiff(this.pointerTargetY);

    // if (this.pointerTargetYDiff >= 1) {
    //   // if (this.player.changeLaneUp()) this.pointerTargetLane--;
    //   this.player.moveUpRoad();
    // } else if (this.pointerTargetYDiff <= -1) {
    //   // if (this.player.changeLaneDown()) this.pointerTargetLane++;
    //   this.player.moveDownRoad();
    // }

    // Will be blocked if already changing lane.
    if (this.isLaneChangingUp) {
      // this.player.changeLaneUp();
      this.player.moveUpRoad();
    } else if (this.isLaneChangingDown) {
      // this.player.changeLaneDown();
      this.player.moveDownRoad();
    }

    /*if(Phaser.Input.Keyboard.JustDown(this.playerControls.accelerate)){
      this.player.isAccelerating = true;
    }
    else if(Phaser.Input.Keyboard.JustUp(this.playerControls.accelerate)){
      this.player.isAccelerating = false;
    }*/

    if (Phaser.Input.Keyboard.JustDown(this.playerControls.changeLaneUp)) {
      // this.player.changeLaneUp();
      this.isLaneChangingUp = true;
    } else if (Phaser.Input.Keyboard.JustUp(this.playerControls.changeLaneUp)) {
      this.isLaneChangingUp = false;
    }

    if (Phaser.Input.Keyboard.JustDown(this.playerControls.changeLaneDown)) {
      // this.player.changeLaneDown();
      this.isLaneChangingDown = true;
    } else if (Phaser.Input.Keyboard.JustUp(this.playerControls.changeLaneDown)) {
      this.isLaneChangingDown = false;
    }

    if (this.allowDebugControls) {
      if (Phaser.Input.Keyboard.JustDown(this.debugControls.autoRun)) {
        if (this.player.IsMoving) {
          this.player.stopMoving();
        } else {
          this.player.startMoving();
        }
      }

      if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleDebugMovement)) {
        this.allowDebugMovement = !this.allowDebugMovement;
        // (this.player.body as MatterJS.BodyType).ignoreGravity = this.allowDebugMovement;
      }

      if (this.allowDebugMovement) {
        // if (this.debugControls.up.isDown || this.debugControls.upSecond.isDown) {
        //   this.player.y -= 1 * delta;
        // }
        // if (this.debugControls.down.isDown || this.debugControls.downSecond.isDown) {
        //   this.player.y += 1 * delta;
        // }

        if (this.debugControls.right.isDown || this.debugControls.rightSecond.isDown) {
          this.player.x += 1 * delta;
        }

        if (this.debugControls.left.isDown || this.debugControls.leftSecond.isDown) {
          this.player.x -= 1 * delta;
        }
      }
    }
  }

  protected onPointerDown(pointer: Phaser.Input.Pointer) {
    this.isPointerDown = true;
    // this.player.accelerate();

    this.getTargetY(pointer.y);
    this.player.moveToY(this.pointerTargetY);

    this.previousPointerY = pointer.y;
  }

  protected onPointerMove(pointer: Phaser.Input.Pointer, currentlyOver: Phaser.GameObjects.GameObject[]) {
    if (!this.isPointerDown) return;

    if (Math.abs(this.previousPointerY - pointer.y) > this.pointerSensitivity) {
      this.getTargetY(pointer.y);
      this.player.moveToY(this.pointerTargetY);
      this.previousPointerY = pointer.y;
    }
  }

  protected onPointerUp() {
    // this.player.decelerate();
    this.isPointerDown = false;
    this.pointerTargetY = this.player.y;
    this.pointerTargetYDiff = 0;
    this.player.moveToY(this.pointerTargetY);
  }

  protected onPointerUpOutside() {
    this.isPointerDown = false;
    this.pointerTargetY = this.player.y;
    this.pointerTargetYDiff = 0;
    this.player.moveToY(this.pointerTargetY);
  }

  protected getTargetY(y: number) {
    // Pointer origin top left and lane boundaries is centre.
    let offsetY = y - this.scene.cameras.main.displayHeight * 0.5;

    // console.log('Current Pointer Lane', this.getLaneFromYPosition(offsetY, this.laneBoundaries));
    // let targetY = this.getLaneFromYPosition(offsetY, this.laneBoundaries);
    this.pointerTargetY = Phaser.Math.Clamp(offsetY, this.player.RoadDetails.roadStartY, this.player.RoadDetails.roadEndY);
    // this.updateTargetYDiff(this.pointerTargetY);
  }

  protected updateTargetYDiff(targetY: number) {
    let diff = this.player.y - targetY;
    this.pointerTargetYDiff = diff;
  }
}
